export const STATUS = {
  NONE: 'none',
  PREFERRED: 'preferred'
};

export const CARD_BADGE_WIDTH = '14px';
export const CARD_BADGE_HEIGHT = '16px';

export const EXPERIMENT_CARD_BADGE_WIDTH = '13px';
export const EXPERIMENT_CARD_BADGE_HEIGHT = '15px';
